
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93CLjrKXI1emzDe_wrIexDYxu30TDpzEUdrpWgv_aFqSAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/[...slug].vue?macro=true";
import { default as _91job_939LMT_452rfmA_45bKphNV6UYUp_453vRSSdfD9Dy8nNZ4SdwwMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/job/[job].vue?macro=true";
import { default as indexxyAQTAkA_5EdelmgwCHtNiU_Ur_456dUAtbOtUqSKmAccMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/blog/index.vue?macro=true";
import { default as ai_45readinessYKD5AlGXU_45g29H0HhmR1381Wk_mVBg_iFj1e_45ZdDEfUMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ai-readiness.vue?macro=true";
import { default as indexYQdn59f9ydrEwMjw1a_45KBct7SU2bk29lKnPVRE3ZvTMMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ebooks/index.vue?macro=true";
import { default as _91_46_46_46slug_93UUUiuADXWTgHxlyBO1LFWUCwkQXZyZbvKbHof1K33uMMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/[...slug].vue?macro=true";
import { default as _91job_93Ei3Qbxvoqti5rgDAmFsWNbduQCcuRzj8tiW9mneJtssMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/job/[job].vue?macro=true";
import { default as _91_46_46_46slug_93uhNJ0nZSAJqz64IP3c_45mq_sELPELXE5Z56n3zZAVb_MMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/[...slug].vue?macro=true";
import { default as _91job_93hUaOeZQ_J5UPrnBzIUGkuZtb2fT4J5BnTVnR_45_1UtuwMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/job/[job].vue?macro=true";
import { default as _91slug_932ABmDiZLLnxmAqf8GrhpdyPoV6oPyULOnAlRGEK5L9UMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/author/[slug].vue?macro=true";
import { default as _91slug_932_45UnICldOvhpJmBUgyo3kJeXa4c_459dTmrSAMprt8SakMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ebooks/[slug].vue?macro=true";
import { default as indexEV2OqBbWHDy8I01mY_45umAaFPT_45M7e_45OCCQr3Q9bLnzUMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/blog/index.vue?macro=true";
import { default as indexfqou34DC1GjsHEWnJHAJVioeanT4kBPsnFKGy_45RSPmwMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/blog/index.vue?macro=true";
import { default as indexImEDxThLrbf7vZ8WsyUcyZOgO2TNj0nkDve2dKmDx8YMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/glossary/index.vue?macro=true";
import { default as indexbJRmaEFlphDqm_45VpNUHaFbJ3CN8hf_457wktQLYVTe7ZkMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/podcasts/index.vue?macro=true";
import { default as indexV5Qb_459DApOm9Me8HkwCrYFKAEcKcqJrptGkD8_7r1E8Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/webinars/index.vue?macro=true";
import { default as indexs6Qzp8_Z2svZ_45TDmQpmdx_450pGn4QHkJA2RbJ0WzDHVcMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/customers/index.vue?macro=true";
import { default as _91slug_93BZiLHH5Mv71pye5Hwl_45jQPNQ0y4vV6LvO2NiNH7fh1sMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/glossary/[slug].vue?macro=true";
import { default as index3fY9T5VlD6NyTSfSGha3UWsViPwjRAQOhZ_45wbI0jc4AMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/ebooks/index.vue?macro=true";
import { default as index8A2yOssyk1TYG9t4ELaHpenxZp8REPk4cqBV3LkQNAEMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/ebooks/index.vue?macro=true";
import { default as _91slug_93vkj7JQxdLZEyitAYR24bljUv89wWo8YNbgDs7wG__agMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/podcasts/[slug].vue?macro=true";
import { default as indexdd6VwB_tMXvX1Zg09VBcEpdt7jrMgh1KYC2nrJB_45JEYMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/resources/index.vue?macro=true";
import { default as _91slug_93bi59eURHrp6v0SC69v_45sD8bZheVstB0SlZTDZr8HBFgMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/webinars/[slug].vue?macro=true";
import { default as _91slug_93wGufhkxz5XxsewRX_M4_sccslEXn90DLb8zeizZAzHgMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/customers/[slug].vue?macro=true";
import { default as _91slug_93VJ5MrAFKf1HPPaqQvBxW6g1ssBSB2SHqTo1jKZjdP9kMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/author/[slug].vue?macro=true";
import { default as _91slug_93L0nwD5GBQwrwXw5lUWBuOw9yXeJ3L20QrLCvubTiLJAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/ebooks/[slug].vue?macro=true";
import { default as _91slug_93fyXr6xEJpUOUYxg1RPNmGXRe4YYBF0gGbspH0IzXFlQMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/author/[slug].vue?macro=true";
import { default as _91slug_93ciGRP7ns6Qks_45Q1__YP_bnK16h41P_qSjQohp2cQMX0Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/ebooks/[slug].vue?macro=true";
import { default as indexSENydcfwaDySxNBRCxCrsBOXHmOjONxSyVenlv3zTpEMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/glossary/index.vue?macro=true";
import { default as indexkqoM5Mq5fog3DiruB_7i6OoZI69zNR_45RrG3SJgJ82BYMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/podcasts/index.vue?macro=true";
import { default as indexIvPgshegeRisabNVmOoiAOyCDksAtVdUKScQk146mU8Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/webinars/index.vue?macro=true";
import { default as indexgiNaiVvlVey_45l2OpkOsWez5MOEReY_45yTAlb3u32AFK0Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/glossary/index.vue?macro=true";
import { default as indexqh4ZJNZr4LjczORB0LyL8O3jamBwmHRPvxZWppXzC2AMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/podcasts/index.vue?macro=true";
import { default as indexPwQJc9Bj7EH4DzeLp32qlaBhPSH7CL1jqUIPbtZ3xBAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/webinars/index.vue?macro=true";
import { default as indexm22y0FcpLoOUBs6SOHkdlsekEFVzPdXYuIV81GhNzIkMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/perspective/index.vue?macro=true";
import { default as indexANRRkE0ax15rZNr3H4Fb11cqiLjOFPyBYtBIlrLMJAgMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/customers/index.vue?macro=true";
import { default as _91slug_931MbH7eqiDlKT4Xk_K7IVXRaPxtG_45gK8KuR3btQZFNqcMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/glossary/[slug].vue?macro=true";
import { default as _91slug_93Lb7Re57ebhBShyQkGHf2kXkFGEgdPhlR5sgNsQq6Q8oMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/podcasts/[slug].vue?macro=true";
import { default as indexWmcEZhak1GXdTi72bb9VHwLUJgqlqF1U8MaDPghnCvQMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/resources/index.vue?macro=true";
import { default as _91slug_93E4mEuQQByOl6oe1OtRblCeE_SSNMVX3zfxqzEH1GscsMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/webinars/[slug].vue?macro=true";
import { default as indexKR9SdCYx5a_uCXw8KaQMXq3sUpdMi2EqkSoE7MQYGOAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/customers/index.vue?macro=true";
import { default as _91slug_93wxQbuSUeybIav33eGQY1fE4deNYluD9MOSvezKRMoCAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/glossary/[slug].vue?macro=true";
import { default as _91slug_938HD_Rh2V3Kp8moh9_45R6t7m3Bu9oG3DYC2CbHVRdNpd8Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/podcasts/[slug].vue?macro=true";
import { default as indexd5ZGbfT2AibllBa_Gc0CulZ3hN6YA_45VE6Dv9OsGlZL4Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/resources/index.vue?macro=true";
import { default as _91slug_93gdSd8inJqRHaIZRA9egsLHxZ2jwj579AAMoz0_9yfuAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/webinars/[slug].vue?macro=true";
import { default as _91slug_93p5g5vtOqTa90RnuSq2G3UOKdsY_45FileXYTHBhqA0I6AMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/perspective/[slug].vue?macro=true";
import { default as _91slug_93ZxHOiYWGiYMbFCnKibGaPK9_45FnE9_45uS74ubcwaW3ReUMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/customers/[slug].vue?macro=true";
import { default as _91slug_93Whayf4zMZa_VRgObxaO9wmTcXR4STHDp7SXE32JaMucMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/customers/[slug].vue?macro=true";
import { default as ai_45readiness_45resultsTM_PPELND6pTJLWnWphagDoVr1hXrIx9Kytn_uvo4a4Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ai-readiness-results.vue?macro=true";
import { default as indexXoVGDL3dlusicBnbd1i4j3FAnke4WNYY2ZvOqRU3VxwMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/perspective/index.vue?macro=true";
import { default as indexmUxoLVAWiHZ2KoulcZWsWJeOu_45gnLZ4qF0_KwhQfq6gMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/perspective/index.vue?macro=true";
import { default as _91slug_93Nu0bPMEEc6RDDQ_AJpEUKPmEAHLcuT91VpYtplyq8hsMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/perspective/[slug].vue?macro=true";
import { default as _91slug_93_z0_MC_eibGzY0A6zlRmuoPCYxrYa4CIyh6p2GdKgnAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/perspective/[slug].vue?macro=true";
import { default as indexfOYN719aprZkdDg5k85Amfv8cmhGIoGUmKs8J6C3HGQMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/product-release/index.vue?macro=true";
import { default as _91slug_93RpD3jOw_0TcmxF2sTDbO0ztk5fkCwKfCtRrYZnENvVAMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/product-release/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93xkch3UftP3Ui7I0JTE1MItPtZ7eMxdGJXAfi_syIF8YMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/block-library/[...slug].vue?macro=true";
import { default as index991scHrgCsHTgnnjtlYw1DgvSyxZyMD_45umd1eXtKM74Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/product-release/index.vue?macro=true";
import { default as indexPQ2ErK_45_452B_BoV84Ta2jE8bH08dXRZhSC_icsKf6c7YMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/product-release/index.vue?macro=true";
import { default as _91slug_938DgNtbjRuCPhrKSHEG2Op8MVYpg8mThiB1o8DgjzkRkMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/product-release/[slug].vue?macro=true";
import { default as _91slug_9328Z2JHLUr5f9ohk4TIuf5U8VOwnwHl5bjKkzg83Tlm4Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/product-release/[slug].vue?macro=true";
import { default as indexrM82657U3a3tEnBSSC1HWTZmolADLriqhcE5EdaAMbwMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/blog/[category_slug]/index.vue?macro=true";
import { default as index8ic9l2phrGmlCEIwEuh5VioJorlDUJcirsCv0DKmK4MMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/blog/[category_slug]/index.vue?macro=true";
import { default as indexDfyrsCt_l86N_4511GQuvLyFic2cnMlRysfpttpYZFt7sMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/blog/[category_slug]/index.vue?macro=true";
import { default as _91blog_page_slug_9322nUVvAHYWyGgcliPDOlsBrDAG_45F3EVzMFmC_454yaQHgMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/blog/[category_slug]/[blog_page_slug].vue?macro=true";
import { default as _91blog_page_slug_93pX2bEZyf6M1bhvN7uSUju3EmoSG_75N2iLKujVW1Oh0Meta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/blog/[category_slug]/[blog_page_slug].vue?macro=true";
import { default as _91blog_page_slug_939mrzB6uOm864NROvO_ANPdo5XJMh8eMVdxRBlcrJ7aYMeta } from "/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/blog/[category_slug]/[blog_page_slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93CLjrKXI1emzDe_wrIexDYxu30TDpzEUdrpWgv_aFqSAMeta || {}), ...{"middleware":"page-section-handle"} },
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/[...slug].vue")
  },
  {
    name: "job-job",
    path: "/job/:job()",
    meta: _91job_939LMT_452rfmA_45bKphNV6UYUp_453vRSSdfD9Dy8nNZ4SdwwMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/job/[job].vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexxyAQTAkA_5EdelmgwCHtNiU_Ur_456dUAtbOtUqSKmAccMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/blog/index.vue")
  },
  {
    name: "ai-readiness",
    path: "/ai-readiness",
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ai-readiness.vue")
  },
  {
    name: "ebooks",
    path: "/ebooks",
    meta: indexYQdn59f9ydrEwMjw1a_45KBct7SU2bk29lKnPVRE3ZvTMMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ebooks/index.vue")
  },
  {
    name: "ja-slug",
    path: "/ja/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93UUUiuADXWTgHxlyBO1LFWUCwkQXZyZbvKbHof1K33uMMeta || {}), ...{"middleware":"page-section-handle"} },
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/[...slug].vue")
  },
  {
    name: "ja-job-job",
    path: "/ja/job/:job()",
    meta: _91job_93Ei3Qbxvoqti5rgDAmFsWNbduQCcuRzj8tiW9mneJtssMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/job/[job].vue")
  },
  {
    name: "ko-slug",
    path: "/ko/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93uhNJ0nZSAJqz64IP3c_45mq_sELPELXE5Z56n3zZAVb_MMeta || {}), ...{"middleware":"page-section-handle"} },
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/[...slug].vue")
  },
  {
    name: "ko-job-job",
    path: "/ko/job/:job()",
    meta: _91job_93hUaOeZQ_J5UPrnBzIUGkuZtb2fT4J5BnTVnR_45_1UtuwMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/job/[job].vue")
  },
  {
    name: "author-slug",
    path: "/author/:slug()",
    meta: _91slug_932ABmDiZLLnxmAqf8GrhpdyPoV6oPyULOnAlRGEK5L9UMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/author/[slug].vue")
  },
  {
    name: "ebooks-slug",
    path: "/ebooks/:slug()",
    meta: _91slug_932_45UnICldOvhpJmBUgyo3kJeXa4c_459dTmrSAMprt8SakMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ebooks/[slug].vue")
  },
  {
    name: "ja-blog",
    path: "/ja/blog",
    meta: indexEV2OqBbWHDy8I01mY_45umAaFPT_45M7e_45OCCQr3Q9bLnzUMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/blog/index.vue")
  },
  {
    name: "ko-blog",
    path: "/ko/blog",
    meta: indexfqou34DC1GjsHEWnJHAJVioeanT4kBPsnFKGy_45RSPmwMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/blog/index.vue")
  },
  {
    name: "glossary",
    path: "/glossary",
    meta: indexImEDxThLrbf7vZ8WsyUcyZOgO2TNj0nkDve2dKmDx8YMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/glossary/index.vue")
  },
  {
    name: "podcasts",
    path: "/podcasts",
    meta: indexbJRmaEFlphDqm_45VpNUHaFbJ3CN8hf_457wktQLYVTe7ZkMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/podcasts/index.vue")
  },
  {
    name: "webinars",
    path: "/webinars",
    meta: indexV5Qb_459DApOm9Me8HkwCrYFKAEcKcqJrptGkD8_7r1E8Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/webinars/index.vue")
  },
  {
    name: "customers",
    path: "/customers",
    meta: indexs6Qzp8_Z2svZ_45TDmQpmdx_450pGn4QHkJA2RbJ0WzDHVcMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/customers/index.vue")
  },
  {
    name: "glossary-slug",
    path: "/glossary/:slug()",
    meta: _91slug_93BZiLHH5Mv71pye5Hwl_45jQPNQ0y4vV6LvO2NiNH7fh1sMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/glossary/[slug].vue")
  },
  {
    name: "ja-ebooks",
    path: "/ja/ebooks",
    meta: index3fY9T5VlD6NyTSfSGha3UWsViPwjRAQOhZ_45wbI0jc4AMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/ebooks/index.vue")
  },
  {
    name: "ko-ebooks",
    path: "/ko/ebooks",
    meta: index8A2yOssyk1TYG9t4ELaHpenxZp8REPk4cqBV3LkQNAEMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/ebooks/index.vue")
  },
  {
    name: "podcasts-slug",
    path: "/podcasts/:slug()",
    meta: _91slug_93vkj7JQxdLZEyitAYR24bljUv89wWo8YNbgDs7wG__agMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/podcasts/[slug].vue")
  },
  {
    name: "resources",
    path: "/resources",
    meta: indexdd6VwB_tMXvX1Zg09VBcEpdt7jrMgh1KYC2nrJB_45JEYMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/resources/index.vue")
  },
  {
    name: "webinars-slug",
    path: "/webinars/:slug()",
    meta: _91slug_93bi59eURHrp6v0SC69v_45sD8bZheVstB0SlZTDZr8HBFgMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/webinars/[slug].vue")
  },
  {
    name: "customers-slug",
    path: "/customers/:slug()",
    meta: _91slug_93wGufhkxz5XxsewRX_M4_sccslEXn90DLb8zeizZAzHgMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/customers/[slug].vue")
  },
  {
    name: "ja-author-slug",
    path: "/ja/author/:slug()",
    meta: _91slug_93VJ5MrAFKf1HPPaqQvBxW6g1ssBSB2SHqTo1jKZjdP9kMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/author/[slug].vue")
  },
  {
    name: "ja-ebooks-slug",
    path: "/ja/ebooks/:slug()",
    meta: _91slug_93L0nwD5GBQwrwXw5lUWBuOw9yXeJ3L20QrLCvubTiLJAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/ebooks/[slug].vue")
  },
  {
    name: "ko-author-slug",
    path: "/ko/author/:slug()",
    meta: _91slug_93fyXr6xEJpUOUYxg1RPNmGXRe4YYBF0gGbspH0IzXFlQMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/author/[slug].vue")
  },
  {
    name: "ko-ebooks-slug",
    path: "/ko/ebooks/:slug()",
    meta: _91slug_93ciGRP7ns6Qks_45Q1__YP_bnK16h41P_qSjQohp2cQMX0Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/ebooks/[slug].vue")
  },
  {
    name: "ja-glossary",
    path: "/ja/glossary",
    meta: indexSENydcfwaDySxNBRCxCrsBOXHmOjONxSyVenlv3zTpEMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/glossary/index.vue")
  },
  {
    name: "ja-podcasts",
    path: "/ja/podcasts",
    meta: indexkqoM5Mq5fog3DiruB_7i6OoZI69zNR_45RrG3SJgJ82BYMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/podcasts/index.vue")
  },
  {
    name: "ja-webinars",
    path: "/ja/webinars",
    meta: indexIvPgshegeRisabNVmOoiAOyCDksAtVdUKScQk146mU8Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/webinars/index.vue")
  },
  {
    name: "ko-glossary",
    path: "/ko/glossary",
    meta: indexgiNaiVvlVey_45l2OpkOsWez5MOEReY_45yTAlb3u32AFK0Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/glossary/index.vue")
  },
  {
    name: "ko-podcasts",
    path: "/ko/podcasts",
    meta: indexqh4ZJNZr4LjczORB0LyL8O3jamBwmHRPvxZWppXzC2AMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/podcasts/index.vue")
  },
  {
    name: "ko-webinars",
    path: "/ko/webinars",
    meta: indexPwQJc9Bj7EH4DzeLp32qlaBhPSH7CL1jqUIPbtZ3xBAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/webinars/index.vue")
  },
  {
    name: "perspective",
    path: "/perspective",
    meta: indexm22y0FcpLoOUBs6SOHkdlsekEFVzPdXYuIV81GhNzIkMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/perspective/index.vue")
  },
  {
    name: "ja-customers",
    path: "/ja/customers",
    meta: indexANRRkE0ax15rZNr3H4Fb11cqiLjOFPyBYtBIlrLMJAgMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/customers/index.vue")
  },
  {
    name: "ja-glossary-slug",
    path: "/ja/glossary/:slug()",
    meta: _91slug_931MbH7eqiDlKT4Xk_K7IVXRaPxtG_45gK8KuR3btQZFNqcMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/glossary/[slug].vue")
  },
  {
    name: "ja-podcasts-slug",
    path: "/ja/podcasts/:slug()",
    meta: _91slug_93Lb7Re57ebhBShyQkGHf2kXkFGEgdPhlR5sgNsQq6Q8oMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/podcasts/[slug].vue")
  },
  {
    name: "ja-resources",
    path: "/ja/resources",
    meta: indexWmcEZhak1GXdTi72bb9VHwLUJgqlqF1U8MaDPghnCvQMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/resources/index.vue")
  },
  {
    name: "ja-webinars-slug",
    path: "/ja/webinars/:slug()",
    meta: _91slug_93E4mEuQQByOl6oe1OtRblCeE_SSNMVX3zfxqzEH1GscsMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/webinars/[slug].vue")
  },
  {
    name: "ko-customers",
    path: "/ko/customers",
    meta: indexKR9SdCYx5a_uCXw8KaQMXq3sUpdMi2EqkSoE7MQYGOAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/customers/index.vue")
  },
  {
    name: "ko-glossary-slug",
    path: "/ko/glossary/:slug()",
    meta: _91slug_93wxQbuSUeybIav33eGQY1fE4deNYluD9MOSvezKRMoCAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/glossary/[slug].vue")
  },
  {
    name: "ko-podcasts-slug",
    path: "/ko/podcasts/:slug()",
    meta: _91slug_938HD_Rh2V3Kp8moh9_45R6t7m3Bu9oG3DYC2CbHVRdNpd8Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/podcasts/[slug].vue")
  },
  {
    name: "ko-resources",
    path: "/ko/resources",
    meta: indexd5ZGbfT2AibllBa_Gc0CulZ3hN6YA_45VE6Dv9OsGlZL4Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/resources/index.vue")
  },
  {
    name: "ko-webinars-slug",
    path: "/ko/webinars/:slug()",
    meta: _91slug_93gdSd8inJqRHaIZRA9egsLHxZ2jwj579AAMoz0_9yfuAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/webinars/[slug].vue")
  },
  {
    name: "perspective-slug",
    path: "/perspective/:slug()",
    meta: _91slug_93p5g5vtOqTa90RnuSq2G3UOKdsY_45FileXYTHBhqA0I6AMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/perspective/[slug].vue")
  },
  {
    name: "ja-customers-slug",
    path: "/ja/customers/:slug()",
    meta: _91slug_93ZxHOiYWGiYMbFCnKibGaPK9_45FnE9_45uS74ubcwaW3ReUMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/customers/[slug].vue")
  },
  {
    name: "ko-customers-slug",
    path: "/ko/customers/:slug()",
    meta: _91slug_93Whayf4zMZa_VRgObxaO9wmTcXR4STHDp7SXE32JaMucMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/customers/[slug].vue")
  },
  {
    name: "ai-readiness-results",
    path: "/ai-readiness-results",
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ai-readiness-results.vue")
  },
  {
    name: "ja-perspective",
    path: "/ja/perspective",
    meta: indexXoVGDL3dlusicBnbd1i4j3FAnke4WNYY2ZvOqRU3VxwMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/perspective/index.vue")
  },
  {
    name: "ko-perspective",
    path: "/ko/perspective",
    meta: indexmUxoLVAWiHZ2KoulcZWsWJeOu_45gnLZ4qF0_KwhQfq6gMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/perspective/index.vue")
  },
  {
    name: "ja-perspective-slug",
    path: "/ja/perspective/:slug()",
    meta: _91slug_93Nu0bPMEEc6RDDQ_AJpEUKPmEAHLcuT91VpYtplyq8hsMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/perspective/[slug].vue")
  },
  {
    name: "ko-perspective-slug",
    path: "/ko/perspective/:slug()",
    meta: _91slug_93_z0_MC_eibGzY0A6zlRmuoPCYxrYa4CIyh6p2GdKgnAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/perspective/[slug].vue")
  },
  {
    name: "product-release",
    path: "/product-release",
    meta: indexfOYN719aprZkdDg5k85Amfv8cmhGIoGUmKs8J6C3HGQMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/product-release/index.vue")
  },
  {
    name: "product-release-slug",
    path: "/product-release/:slug()",
    meta: _91slug_93RpD3jOw_0TcmxF2sTDbO0ztk5fkCwKfCtRrYZnENvVAMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/product-release/[slug].vue")
  },
  {
    name: "block-library-slug",
    path: "/block-library/:slug(.*)*",
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/block-library/[...slug].vue")
  },
  {
    name: "ja-product-release",
    path: "/ja/product-release",
    meta: index991scHrgCsHTgnnjtlYw1DgvSyxZyMD_45umd1eXtKM74Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/product-release/index.vue")
  },
  {
    name: "ko-product-release",
    path: "/ko/product-release",
    meta: indexPQ2ErK_45_452B_BoV84Ta2jE8bH08dXRZhSC_icsKf6c7YMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/product-release/index.vue")
  },
  {
    name: "ja-product-release-slug",
    path: "/ja/product-release/:slug()",
    meta: _91slug_938DgNtbjRuCPhrKSHEG2Op8MVYpg8mThiB1o8DgjzkRkMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/product-release/[slug].vue")
  },
  {
    name: "ko-product-release-slug",
    path: "/ko/product-release/:slug()",
    meta: _91slug_9328Z2JHLUr5f9ohk4TIuf5U8VOwnwHl5bjKkzg83Tlm4Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/product-release/[slug].vue")
  },
  {
    name: "blog-category_slug",
    path: "/blog/:category_slug()",
    meta: indexrM82657U3a3tEnBSSC1HWTZmolADLriqhcE5EdaAMbwMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/blog/[category_slug]/index.vue")
  },
  {
    name: "ja-blog-category_slug",
    path: "/ja/blog/:category_slug()",
    meta: index8ic9l2phrGmlCEIwEuh5VioJorlDUJcirsCv0DKmK4MMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/blog/[category_slug]/index.vue")
  },
  {
    name: "ko-blog-category_slug",
    path: "/ko/blog/:category_slug()",
    meta: indexDfyrsCt_l86N_4511GQuvLyFic2cnMlRysfpttpYZFt7sMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/blog/[category_slug]/index.vue")
  },
  {
    name: "blog-category_slug-blog_page_slug",
    path: "/blog/:category_slug()/:blog_page_slug()",
    meta: _91blog_page_slug_9322nUVvAHYWyGgcliPDOlsBrDAG_45F3EVzMFmC_454yaQHgMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/blog/[category_slug]/[blog_page_slug].vue")
  },
  {
    name: "ja-blog-category_slug-blog_page_slug",
    path: "/ja/blog/:category_slug()/:blog_page_slug()",
    meta: _91blog_page_slug_93pX2bEZyf6M1bhvN7uSUju3EmoSG_75N2iLKujVW1Oh0Meta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ja/blog/[category_slug]/[blog_page_slug].vue")
  },
  {
    name: "ko-blog-category_slug-blog_page_slug",
    path: "/ko/blog/:category_slug()/:blog_page_slug()",
    meta: _91blog_page_slug_939mrzB6uOm864NROvO_ANPdo5XJMh8eMVdxRBlcrJ7aYMeta || {},
    component: () => import("/home/runner/work/delight.ai/delight.ai/frontend/pages/ko/blog/[category_slug]/[blog_page_slug].vue")
  }
]